import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import UserCredential from './Credential';
import { ICredential } from '../../_types/user';
import { Button, Grid } from '@material-ui/core';
import { IPolicyObject } from '../../_types/ewpolicy';
import { GetCredentials, LogOutAllDevices } from '../../_service/user';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import NewEmailDialog from './NewEmailDialog';

interface Props {
    policyObject: IPolicyObject;
};



const UserCredentials: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [creds, setCreds] = useState<ICredential[] | null>(null);
    const [showEmail, setShowEmail] = useState<boolean>(false);

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();

    React.useEffect(() => {

        let id = prop.policyObject.id!;

        GetCredentials(id).then(r => {
            setCreds(r);
    
    });

    
    },[])

    const logOutAllDevices = () => {
        let id = prop.policyObject.id!;
        LogOutAllDevices(id).then(r => {
          if (r) {
            

            GetCredentials(id).then(c => {
                setCreds(c);
            })

          }
        });
      }

    const credentialChanged = (c: ICredential) => {

        let id = prop.policyObject.id!;
        GetCredentials(id).then(r => {
            setCreds(r);
        })
        
    }

    const newEmailDialogAction = (cred: ICredential | null) => {
        
        setShowEmail(false);
        if (cred) {
            GetCredentials(prop.policyObject.id!).then(r => {
                setCreds(r);
            })
        }
    }

    return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                    <Grid item>
                        <Button variant="contained" size="small" color="secondary" onClick={(e) => { logOutAllDevices() }}>Log out of all devices</Button>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" size="small" color="secondary" onClick={(e) => {setShowEmail(true)}}>New Email</Button>
                        <NewEmailDialog user={prop.policyObject} open={showEmail} onChange={newEmailDialogAction}/>
                    </Grid>
                    {/* <Grid item>
                        <Button variant="contained" size="small" color="secondary" onClick={(e) => {}}>New Phone</Button>
                    </Grid> */}
                    
                </Grid>
            </Grid>
            <Grid item>
            {creds && (
                <Paper >
                    <TableContainer className={classes.table} >
                        <Table stickyHeader size="small" >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Type</TableCell>
                                    <TableCell align="left">Token</TableCell>
                                    <TableCell align="left">Issued</TableCell>
                                    <TableCell align="left">Attempts</TableCell>
                                    <TableCell align="left">Expired</TableCell>
                                    <TableCell align="left">Locked</TableCell>
                                    <TableCell align="left">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {creds.map((c, i) => {
                                return (
                                    <UserCredential key={i} credential={c} onChange={credentialChanged}/>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
            </Grid>
        </Grid>
    )
    
}

export default UserCredentials;